<template>
  <div>
    <b-button
      style="margin-bottom: 10px;"
      variant="primary"
      @click="allPechat"
      class="navbarBtnTashxis"
    >
      <b-icon icon="printer-fill"></b-icon>
      Печать
    </b-button>
    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2 mr-2 ml-2"
      v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
      @click="getShablonDoctor('bayonnoma', { type: false })"
    >
      <b-icon icon="arrow-down-circle-fill"></b-icon>
    </b-button>

    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2"
      @click="(status = 'bayonnoma'), (row_click_type = { type: false })"
      v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
    >
      <b-icon icon="arrow-up-circle-fill"></b-icon>
    </b-button>
    <b-modal
      :id="'modal-shablon' + 'bayonnoma' + modalIdCom"
      size="lg"
      :title="$t('Шаблонлар рўйхати')"
      hide-footer
    >
      <Shablon
        :modalIdCom="modalIdCom"
        :plus_dont_show="true"
        :shabType="'bayonnoma'"
        :itemsShablon="itemsShablon"
        @ShablonGet="getShablon"
        @RowClickedShab="RowClickedShab"
      />
    </b-modal>
    <b-modal
      :id="'modal-new-shab-creat-bayonnoma' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      hide-footer
    >
      <div>
        <div>
          <b-input type="text" v-model="name"></b-input>
        </div>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="ShifokorShablonClose"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="ShifokorShablon"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div
      style="font-size: 35px; font-weight: 600; text-align: center; font-family: 'Times New Roman';"
    >
      TUG'RUQ TIBBIY KARTA №
      <input
        type="number"
        class="input-stile"
        style="font-size: 35px; font-weight: 600; width: 170px; margin-bottom: 5px;"
        @input="changeHistoryId"
        v-model="historyId"
      />
    </div>
    <div style="display: flex; justify-content: space-between;">
      <div class="stat-bemor-text">
        <label>F.I.O: {{ $store.state.bemor.fullname }}</label> <br/>
        <div class="display-flex">
          <label>Millati:</label>
          <div
            @click="
              selectKey('value7'),
                (row_click_type = { type: true, value: 'value7' })
            "
            style="width: 300px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value7"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <div class="display-flex ml-3">
            <label>Qabul qilingan vaqti:</label>
            <input
              v-model="selectShablonJson.value1"
              class="input-stile"
              type="date"
              @input="textChange"
            />
          </div>
        </div>
        <div class="display-flex">
          <label>Qon guruhi:</label>
          <input
            v-model="selectShablonJson.value8"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value8', 'value8')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 70px;"
          />
          <label>Gemoglobini </label>
          <input
            v-model="selectShablonJson.value22"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value22', 'value22')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 100px;"
          />
          <label>rezus mansubligi </label>
          <div
            @click="
              selectKey('value23'),
                (row_click_type = { type: true, value: 'value23' })
            "
            style="width: 300px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value23"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div>
          <label>Antitelolar</label>
          <input
            v-model="selectShablonJson.value10"
            type="text"
            @blur="handleBlur($event)"
            @input="textChange($event)"
            @focus="showDiv($event, 'value10', 'value10')"
            class="input-stile"
            style="width: calc(100% - 210px);"
          />
        </div>
        <div class="display-flex">
          <label>Tug'ruqxonadan chiqish vaqti:</label>
          <input
            v-model="selectShablonJson.value2"
            class="input-stile"
            type="date"
            @input="textChange"
          />
        </div>
        <div class="display-flex">
          <label>Allergik ta'sirchanligi:</label>
          <div
            @click="
              selectKey('value24'),
                (row_click_type = { type: true, value: 'value24' })
            "
            style="width: 400px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value24"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div>
          <label>Yotgan kunlar soni</label>
          <input
            v-model="selectShablonJson.value3"
            class="input-stile"
            style="width: 100px;"
            @focus="showDiv($event, 'value3', 'value3')"
            @blur="handleBlur($event)"
            type="text"
            @input="textChange($event)"
          />
          <label>RW</label>
          <input
            v-model="selectShablonJson.value4"
            class="input-stile"
            @blur="handleBlur($event)"
            @input="textChange($event)"
            @focus="showDiv($event, 'value4', 'value4')"
            type="text"
          />
        
          <label>xona</label>
          <input
            v-model="selectShablonJson.value5"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value5', 'value5')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 200px;"
          />
        </div>
        <div>
          <label>Suzuk bo'yicha tekshiruv</label>
          <input
            v-model="selectShablonJson.value6"
            @input="textChange($event)"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value6', 'value6')"
            class="input-stile"
            style="width: 500px;"
          />
          <!-- <label>kun yotib davolangan</label> -->
        </div>
        <label>
          Doimiy yashash joyi
          {{
            $store.state.bemor.region ? $store.state.bemor.region.name : ""
          }}
          {{
            $store.state.bemor.district
              ? $store.state.bemor.district.name
              : ""
          }}
          {{ $store.state.bemor.addres }}
        </label>
        <div class="display-flex">
          <label>Oilaviy axvoli</label>
          <div
            @click="
              selectKey('value25'),
                (row_click_type = { type: true, value: 'value25' })
            "
            style="width: 400px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value25"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <label>Ish joyi, kasbi, lavozimi</label>
        <input
          v-model="selectShablonJson.value26"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value26', 'value26')"
          type="text"
          style="width: calc(100% - 210px); margin-bottom: 5px;"
        />
        <div class="display-flex">
          <label>Xomiladorlik vaqtida Shifokor (doya) nazoratida bo'lganmi </label>
          <div
            @click="
              selectKey('value27'),
                (row_click_type = { type: true, value: 'value27' })
            "
            style="width: 170px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value27"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <label>Necha marta</label>
          <input
            v-model="selectShablonJson.value28"
            class="input-stile"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value28', 'value28')"
            type="text"
            style="width: 150px; margin-bottom: 5px;"
          />
        </div>
        <label>Akusher-ginekolog tibbiy ko'rigi soni</label>
        <input
          v-model="selectShablonJson.value29"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value29', 'value29')"
          type="text"
          style="width: 150px; margin-bottom: 5px;"
        />
        <br>
        <label>Klinik tashxis:</label>
        <input
          v-model="selectShablonJson.value30"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value30', 'value30')"
          type="text"
          style="width: 100%; margin-bottom: 5px;"
        />
        <br>
        <label>Yakuniy tashxis:</label>
        <input
          v-model="selectShablonJson.value31"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value31', 'value31')"
          type="text"
          style="width: 100%; margin-bottom: 5px;"
        />
        <br>
        <label>Tug'ish jarayonida, tug'ruqdan keyingi asoratlar:</label>
        <input
          v-model="selectShablonJson.value32"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value32', 'value32')"
          type="text"
          style="width: 100%; margin-bottom: 5px;"
        />
        <label>O'tkazilgan jarroxlik amaliyoti nomi:</label>
        <input
          v-model="selectShablonJson.value33"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value33', 'value33')"
          type="text"
          style="width: 100%; margin-bottom: 5px;"
        />

        <input
          v-model="selectShablonJson.value34"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value34', 'value34')"
          type="text"
          style="width: 100%; margin-bottom: 5px;"
        />

        <label>(Ayolning o'zidan olingan ma'lumotlar)</label><br>
        <label>Umumiy xastalik</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
          @click="
            getShablonDoctor('qabulxonavalue35', {
              type: true,
              value: 'value35'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (key = 'qabulxonavalue35'),
              (row_click_type = { type: true, value: 'value35' })
          "
          v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value35"
          @input="textChange($event)"
          style="width: 100%; height: 100px;"
        ></textarea>
        <label>Erining salomatligi</label>
        <input
          v-model="selectShablonJson.value36"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value36', 'value36')"
          type="text"
          style="width: 100%; margin-bottom: 5px;"
        />
        <label>Xayz ko'rish</label>
        <input
          v-model="selectShablonJson.value37"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value37', 'value37')"
          type="text"
          style="width: 70px;"
        />
        <label>Yoshdan boshlangan</label>
        <input
          v-model="selectShablonJson.value38"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value38', 'value38')"
          type="text"
          style="width: 100px; margin-bottom: 5px;"
        />
        <label>(turmushga chiqqan)</label> <br>
        <label>Ginakologik kasalliklar</label>
        <input
          v-model="selectShablonJson.value39"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value39', 'value39')"
          type="text"
          style="width: 100%;"
        />
        <label>Avvalgi xomiladorliklari</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
          @click="
            getShablonDoctor('qabulxonavalue40', {
              type: true,
              value: 'value40'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (key = 'qabulxonavalue40'),
              (row_click_type = { type: true, value: 'value40' })
          "
          v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value40"
          @input="textChange($event)"
          style="width: 100%; height: 100px;"
        ></textarea>
        <label>necta bolasi hayot</label>
        <input
          v-model="selectShablonJson.value41"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value41', 'value41')"
          type="text"
          style="width: 600px;"
        /> <br>
        <label>O'lik tug'ilganlari</label>
        <input
          v-model="selectShablonJson.value42"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value42', 'value42')"
          type="text"
          style="width: 600px;"
        /> <br>
        <label>Nobut bo'lganlari</label>
        <input
          v-model="selectShablonJson.value43"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value43', 'value43')"
          type="text"
          style="width: 600px"
        />
        <label>Mazkur xomiladorlikning kechikishi va asoratlari</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
          @click="
            getShablonDoctor('qabulxonavalue44', {
              type: true,
              value: 'value44'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (key = 'qabulxonavalue44'),
              (row_click_type = { type: true, value: 'value44' })
          "
          v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value44"
          @input="textChange($event)"
          style="width: 100%; height: 100px;"
        ></textarea>
        <label>Tug'ruq xonaga tushgan vaqtidagi holati</label>
        <input
          v-model="selectShablonJson.value45"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value45', 'value45')"
          type="text"
          style="width: 550px"
        />
        <br>
        <label>Ko'zdan kechirish natijalari</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
          @click="
            getShablonDoctor('qabulxonavalue46', {
              type: true,
              value: 'value46'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (key = 'qabulxonavalue46'),
              (row_click_type = { type: true, value: 'value46' })
          "
          v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value46"
          @input="textChange($event)"
          style="width: 100%; height: 100px;"
        ></textarea>
        <label>Yuragi</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
          @click="
            getShablonDoctor('qabulxonavalue47', {
              type: true,
              value: 'value47'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (key = 'qabulxonavalue47'),
              (row_click_type = { type: true, value: 'value47' })
          "
          v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value47"
          @input="textChange($event)"
          style="width: 100%; height: 100px;"
        ></textarea>
      </div>
      <div class="stat-bemor-text">
        
        <label>Tomir urishi</label>
        <input
          v-model="selectShablonJson.value48"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value48', 'value48')"
          type="text"
          style="width: 600px"
        />
        <label>O'ng qo'ldagi arterial qon bosimi</label>
        <input
          v-model="selectShablonJson.value49"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value49', 'value49')"
          type="text"
          style="width: 600px"
        />
        <label>Chap qo'ldagi arterial qon bosimi</label>
        <input
          v-model="selectShablonJson.value50"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value50', 'value50')"
          type="text"
          style="width: 600px"
        />
        <label>Nafas olish a'zolari</label>
        <input
          v-model="selectShablonJson.value51"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value51', 'value51')"
          type="text"
          style="width: 600px"
        />
        <label>Ovqat hazm qlish tizimi a'zolari</label>
        <input
          v-model="selectShablonJson.value52"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value52', 'value52')"
          type="text"
          style="width: 600px"
        />
        <label>Siydik-tanosil tizimi a'zolari</label>
        <input
          v-model="selectShablonJson.value53"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value53', 'value53')"
          type="text"
          style="width: 600px"
        />
        <label>Peshob sentrafugasi</label>
        <input
          v-model="selectShablonJson.value54"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value54', 'value54')"
          type="text"
          style="width: 700px"
        />
        <label>Shifokorning F.I.O imzo</label>
        <input
          v-model="selectShablonJson.value55"
          class="input-stile mb-5"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value55', 'value55')"
          type="text"
          style="width: 600px"
        /> <br/>
        <label>Bo'yi</label>
        <input
          v-model="selectShablonJson.value56"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value56', 'value56')"
          type="text"
          style="width: 100px"
        />
        <label>sm Vazni</label>
        <input
          v-model="selectShablonJson.value57"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value57', 'value57')"
          type="text"
          style="width: 100px"
        />
        <label>Xarorati</label>
        <input
          v-model="selectShablonJson.value58"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value58', 'value58')"
          type="text"
          style="width: 100px"
        /> <br/>
        <label>Nechanchi xomiladorlish</label>
        <input
          v-model="selectShablonJson.value59"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value59', 'value59')"
          type="text"
          style="width: 100px"
        />
        <label>Nechanchi tug'ishi</label>
        <input
          v-model="selectShablonJson.value60"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value60', 'value60')"
          type="text"
          style="width: 100px"
        /> <br/>
        <label>xomilaning brinchi bor qimirlashi</label>
        <input
          v-model="selectShablonJson.value61"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value61', 'value61')"
          type="text"
          style="width: 500px"
        />
        <br>
        <label>D. Sp</label>
        <input
          v-model="selectShablonJson.value62"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 70px"
        />
        <label>D. Cr</label>
        <input
          v-model="selectShablonJson.value63"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 70px"
        />
        <label>D. Tr</label>
        <input
          v-model="selectShablonJson.value64"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 70px"
        />
        <label>T. vera</label>
        <input
          v-model="selectShablonJson.value65"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 270px"
        />
        <br>
        <label>Qorin aylanishi</label>
        <input
          v-model="selectShablonJson.value66"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 70px"
        />
        <label>sm</label>
        <label>Bachadon tubining balandligi</label>
        <input
          v-model="selectShablonJson.value67"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 70px"
        />
        <label>sm</label>
        <br>
        <label>Xomila joylanishi, o'rni va ko'rinishi</label>
        <input
          v-model="selectShablonJson.value68"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value68', 'value68')"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Xomila yurak urishi, joyi, soni</label>
        <input
          v-model="selectShablonJson.value69"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value69', 'value69')"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Xomilaning oldin kelgan qismi</label>
        <input
          v-model="selectShablonJson.value70"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value70', 'value70')"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Joylashgan joyi</label>
        <input
          v-model="selectShablonJson.value71"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value71', 'value71')"
          type="text"
          style="width: 270px"
        />
        <label>Tug'ish faoliyati</label>
        <input
          v-model="selectShablonJson.value72"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value72', 'value72')"
          type="text"
          style="width: 270px"
        />
        <br>
        <label>Xomilaning taxminiy og'irligi</label>
        <input
          v-model="selectShablonJson.value73"
          class="input-stile"
          @input="textChange($event)"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Shifokor</label>
        <input
          v-model="selectShablonJson.value74"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value74', 'value74')"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Doya</label>
        <input
          v-model="selectShablonJson.value75"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value75', 'value75')"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Chaqaloq gonoblenoreyaga qarshi muhofazalandi</label>
        <input
          v-model="selectShablonJson.value76"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value76', 'value76')"
          type="text"
          style="width: 370px"
        />
        <br>
        <label>Chaqaloqning Apgar shkalasi bo'yicha baxosi</label> <br>
        <label>Holati</label>
        <input
          v-model="selectShablonJson.value77"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value77', 'value77')"
          type="text"
          style="width: 100px"
        />
        <label>ball</label>
        <label>Tug'ruqdan </label>
        <input
          v-model="selectShablonJson.value78"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value78', 'value78')"
          type="text"
          style="width: 400px"
        />
        <br>
        <div class="display-flex">
          <label>Bolalik joyi</label>
          <div
            @click="
              selectKey('value79'),
                (row_click_type = { type: true, value: 'value79' })
            "
            style="width: 350px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value79"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <label>Qog'onog'i</label>
          <input
            v-model="selectShablonJson.value80"
            class="input-stile"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value80', 'value80')"
            type="text"
            style="width: 300px"
          />
        </div>
        <div class="display-flex">
          <label>Kindik uzunligi</label>
          <input
            v-model="selectShablonJson.value81"
            class="input-stile"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value81', 'value81')"
            type="text"
            style="width: 100px"
          />
          <label>sm</label>
          <input
            v-model="selectShablonJson.value82"
            class="input-stile"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value82', 'value82')"
            type="text"
            style="width: 200px"
          />
        </div>
        <div class="display-flex mt-2">
          <label>Atrofiga o'ralib qolgan:</label>
          <div
            @click="
              selectKey('value83'),
                (row_click_type = { type: true, value: 'value83' })
            "
            style="width: 500px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value83"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex mt-2">
          <label>Hususiyati:</label>
          <div
            @click="
              selectKey('value84'),
                (row_click_type = { type: true, value: 'value84' })
            "
            style="width: 500px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value84"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <label>Tugruq paytida kelgan qon</label>
        <input
          v-model="selectShablonJson.value85"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value85', 'value85')"
          type="text"
          style="width: 100px"
        />
        <label>ml.</label>
        <br>
        <label>Shifokorning F.I.O imzo</label>
        <input
          v-model="selectShablonJson.value86"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value86', 'value86')"
          type="text"
          style="width: 100px"
        />
        <h3 style="text-align: center; font-family: 'Times New Roman';">
          Tug'ruqning borishi
        </h3>
        <label>To'goq</label>
        <input
          v-model="selectShablonJson.value87"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value87', 'value87')"
          type="text"
          style="width: 200px"
        />
        <label>boshlandi Suv</label>
        <input
          v-model="selectShablonJson.value88"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value88', 'value88')"
          type="text"
          style="width: 200px"
        />
        <label>kela boshladi</label>
        <br>
        <label>Suvning hajmi, sifati</label>
        <input
          v-model="selectShablonJson.value89"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value89', 'value89')"
          type="text"
          style="width: 400px"
        />
        <br>
        <label>Bachadon to'la ochildi</label>
        <input
          v-model="selectShablonJson.value90"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value90', 'value90')"
          type="text"
          style="width: 200px"
        />
        <label>Kuchanish boshlandi</label>
        <input
          v-model="selectShablonJson.value91"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value91', 'value91')"
          type="text"
          style="width: 200px"
        />
        <br>
        <label><b>Bola tug'ildi:</b></label>
        <br>
        <label>Birinchisi</label>
        <input
          v-model="selectShablonJson.value92"
          class="input-stile"
          @input="textChange($event)"
          type="datetime-local"
          style="width: 200px"
        />
        <input
          v-model="selectShablonJson.value93"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value93', 'value93')"
          type="text"
          style="width: 400px"
        />
        <br>
        <label>Jinsi</label>
        <input
          v-model="selectShablonJson.value94"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value94', 'value94')"
          type="text"
          style="width: 100px"
        />
        <label>vazni</label>
        <input
          v-model="selectShablonJson.value95"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value95', 'value95')"
          type="text"
          style="width: 100px"
        />
        <label>bo'yi</label>
        <input
          v-model="selectShablonJson.value96"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value96', 'value96')"
          type="text"
          style="width: 100px"
        />
        <label>Bosh aylanasi</label>
        <input
          v-model="selectShablonJson.value97"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value97', 'value97')"
          type="text"
          style="width: 100px"
        />
        <label>sm Ko'krak aylanasi</label>
        <input
          v-model="selectShablonJson.value98"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value98', 'value98')"
          type="text"
          style="width: 100px"
        />
        <br>
        <label>Ikkinchisi</label>
        <input
          v-model="selectShablonJson.value99"
          class="input-stile"
          @input="textChange($event)"
          type="datetime-local"
          style="width: 200px"
        />
        <input
          v-model="selectShablonJson.value100"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value100', 'value100')"
          type="text"
          style="width: 400px"
        />
        <br>
        <label>Jinsi</label>
        <input
          v-model="selectShablonJson.value101"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value101', 'value101')"
          type="text"
          style="width: 100px"
        />
        <label>vazni</label>
        <input
          v-model="selectShablonJson.value102"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value102', 'value102')"
          type="text"
          style="width: 100px"
        />
        <label>bo'yi</label>
        <input
          v-model="selectShablonJson.value103"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value103', 'value103')"
          type="text"
          style="width: 100px"
        />
        <label>Bosh aylanasi</label>
        <input
          v-model="selectShablonJson.value104"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value104', 'value104')"
          type="text"
          style="width: 100px"
        />
        <label>sm Ko'krak aylanasi</label>
        <input
          v-model="selectShablonJson.value105"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value105', 'value105')"
          type="text"
          style="width: 100px"
        />
        <br>
        <label>Ruhiy muhofaza tayyorgarligi o'tkazildi, dori -darmonlar berildi, og'riqsizlantiruvchi vositalar qilindi</label>
        <input
          v-model="selectShablonJson.value106"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value106', 'value106')"
          type="text"
          style="width: 100%"
        />
        <input
          v-model="selectShablonJson.value107"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value107', 'value107')"
          type="text"
          style="width: 400px"
        />
        <br>
        <label><b>Tug'ruqning davom etishi</b></label>
        <br>
        <label>Umumiy</label>
        <input
          v-model="selectShablonJson.value108"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value108', 'value108')"
          type="text"
          style="width: 100px"
        />
        <label>I-davr</label>
        <input
          v-model="selectShablonJson.value109"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value109', 'value109')"
          type="text"
          style="width: 100px"
        />
        <label>II-davr</label>
        <input
          v-model="selectShablonJson.value110"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value110', 'value110')"
          type="text"
          style="width: 100px"
        />
        <label>III-davr</label>
        <input
          v-model="selectShablonJson.value111"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value111', 'value111')"
          type="text"
          style="width: 100px"
        />
        <label>Bolani qabul qilgan (doya, vrach F.I.O)</label>
        <input
          v-model="selectShablonJson.value112"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value112', 'value112')"
          type="text"
          style="width: 100%"
        />
        <label>Yo'ldoshni tekshiruvchi</label>
        <input
          v-model="selectShablonJson.value113"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value113', 'value113')"
          type="text"
          style="width: 400px"
        />
        <br>
        <label>Navbatchi virach</label>
        <input
          v-model="selectShablonJson.value114"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value114', 'value114')"
          type="text"
          style="width: 400px"
        />
        <br>
        <label>Doya</label>
        <input
          v-model="selectShablonJson.value115"
          class="input-stile"
          @input="textChange($event)"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value115', 'value115')"
          type="text"
          style="width: 400px"
        />
      </div>
    </div>
    <b-modal
      :id="'shablon-select' + 'select-bay' + modalIdCom"
      size="xl"
      hide-footer
    >
      <div style="display: flex; justify-content: space-between;">
        <button
          class="navbarBtnTashxis mb-2"
          v-b-modal="'modal-shab-select-create' + modalIdCom"
          @click="plusClick"
        >
          <b-icon icon="plus-lg"></b-icon>
        </button>

        <b-form-group
          label-for="filterTekshiruvlar-input"
          label-cols-sm="1"
          label-align-sm="right"
          label-size="sm"
          class="mb-2 col-8"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterTekshiruvlar-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Қидирув')"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                variant="danger"
                @click="filter = ''"
              >
                {{ $t("Тозалаш") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div>
        <b-table
          id="bemor-table"
          ref="refTable"
          hover
          sort-icon-left
          striped
          primary-key="id"
          :items="itemShablon"
          :fields="fields"
          :filter="filter"
          :current-page="currentPage"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @row-clicked="RowClickedShab($event, null, true)"
          stacked="md"
          show-empty
          small
          @filtered="onFiltered"
        >
          <template #cell(№)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(actions)="row">
            <b-row class="ml-1">
              <section
                style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
              >
                <div style="display: flex;">
                  <b-button
                    v-b-modal="'modal-shab-select-create' + modalIdCom"
                    variant="outline-primary"
                    @click="userLink(row.item)"
                    class="pencil"
                  >
                    <b-icon
                      style="width: 15px;"
                      variant="outline-primary"
                      icon="pencil-fill"
                      aria-hidden="true"
                    ></b-icon>
                  </b-button>
                  <div>
                    <b-button
                      class="trash ml-2"
                      style=""
                      variant="outline-danger"
                      @click="trash(row.item.id)"
                    >
                      <b-icon
                        style="width: 15px;"
                        icon="trash-fill"
                        aria-hidden="true"
                      ></b-icon>
                    </b-button>
                  </div>
                </div>
              </section>
            </b-row>
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal
      :id="'modal-shab-select-create' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      size="lg"
      hide-footer
    >
      <div>
        <b-input
          type="text"
          style="border: 1px solid #ccc; border-radius: 5px;"
          v-model="datas.name"
        >
        </b-input>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="Close()"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="Shablon()"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div
      :style="{
        top: divPosition.top + 'px',
        left: divPosition.left + 'px',
        width: divPosition.width + 'px',
        display: show ? 'block' : 'none'
      }"
      class="dynamic-div"
    >
      <div
        v-for="item in itemShablon"
        class="drop-down"
        @click="selectItemValue(item.name)"
      >
        {{ item.name }}
        <div class="display-flex">
          <b-button
            v-b-modal="'modal-shab-select-create' + modalIdCom"
            variant="outline-primary"
            style="width: 30px; height: 30px"
            @click="userLink(row.item)"
            class="pencil"
          >
            <b-icon
              style="width: 10px;"
              variant="outline-primary"
              icon="pencil-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
          <b-button
            class="trash ml-2"
            style="width: 30px; height: 30px"
            variant="outline-danger"
            @click="trash(item.id)"
          >
            <b-icon
              style="width: 10px;"
              icon="trash-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
        </div>
      </div>
      <b-button
        class="insertbtn"
        style="align-items: center; text-align: center"
        variant="success"
        @click="setStatus(45)"
        v-b-modal="'modal-shab-select-create' + modalIdCom"
      >
        <b-icon icon="plus" color="#fff"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Shablon from "../Shifokor/Shablon.vue";
export default {
  props: ["statsionar_text", "history_id", "modalIdCom"],
  components: {
    Shablon
  },
  data() {
    return {
      historyId: null,
      options: [],
      show: false,
      divPosition: {
        top: 0,
        left: 0,
        with: 0
      },
      datas: {
        id: 0,
        name: "",
        status: ""
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      itemsShablon: [],
      name: "",
      selectShablonJson: {},
      itemShablon: [],
      status: "",
      row_click_type: {
        type: false,
        value: ""
      },
      key: null,
      ValueSelect: "",
      fields: [
        "№",
        { key: "name", label: "Номи", sortable: true },
        { key: "actions", label: "" }
      ],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created() {
    this.historyId = this.history_id;
    if (this.statsionar_text == "" || !this.statsionar_text) {
      this.selectShablonJson = {
        value1: null,
        value2: null,
        value3: null,
        value4: null,
        value5: null,
        value6: null,
        value7: null,
        value8: null,
        value9: null,
        value10: null,
        value11: null,
        value12: null,
        value13: null,
        value14: null,
        value15: null,
        value16: null,
        value17: null,
        value18: null,
        value19: null,
        value20: null,
        value21: null,
        value22: null,
        value23: null,
        value24: null,
        value25: null,
        value26: null,
        value27: null,
        value28: null,
        value29: null,
        value30: null,
        value31: null,
        value32: null,
        value33: null,
        value34: null,
        value35: null,
        value36: null,
        value37: null,
        value38: null,
        value39: null,
        value40: null,
        value41: null,
        value42: null,
        value43: null,
        value44: null,
        value45: null,
        value46: null,
        value47: null,
        value48: null,
        value49: null,
        value50: null,
        value51: null,
        value52: null,
        value53: null,
        value54: null,
        value55: null,
        value56: null,
        value57: null,
        value58: null,
        value59: null,
        value60: null,
        value61: null,
        value62: null,
        value63: null,
        value64: null,
        value65: null,
        value66: null,
        value67: null,
        value68: null,
        value69: null,
        value70: null,
        value71: null,
        value72: null,
        value73: null,
        value74: null,
        value75: null,
        value76: null,
        value77: null,
        value78: null,
        value79: null,
        value80: null,
        value81: null,
        value82: null,
        value83: null,
        value84: null,
        value85: null,
        value86: null,
        value87: null,
        value88: null,
        value89: null,
        value90: null,
        value91: null,
        value92: null,
        value93: null,
        value94: null,
        value95: null,
        value96: null,
        value97: null,
        value98: null,
        value99: null,
        value100: null,
        value101: null,
        value102: null,
        value103: null,
        value104: null,
        value105: null,
        value106: null,
        value107: null,
        value108: null,
        value109: null,
        value110: null,
        value111: null,
        value112: null,
        value113: null,
        value114: null,
        value115: null
      };
    } else {
      this.selectShablonJson = JSON.parse(this.statsionar_text.toString());
    }
  },
  watch: {
    history_id(newval) {
      this.historyId = newval;
    },
    statsionar_text(newVal, old) {
      this.selectShablonJson = JSON.parse(newVal.toString());
    }
  },
  methods: {
    allPechat() {
      let t = {};
      t = {
        doc_type: "tuguruq",
        bemor: this.$store.state.bemor,
        value: this.statsionar_text
      };
      localStorage.setItem("bayonnoma", JSON.stringify(t));
      const rout = this.$router.resolve({
        path: "/user-bayonnoma"
      });
      window.open(rout.href, "_blank");
    },
    selectItemValue(value) {
      if (this.selectShablonJson[`${this.status}`] == null) {
        this.selectShablonJson[`${this.status}`] = value;
      } else {
        this.selectShablonJson[`${this.status}`] += ` ${value}`;
      }
      this.show = false;
      this.textChange();
    },
    showDiv(event, key, status) {
      this.status = key;
      this.getShablon(status);
      const input = event.target;
      const rect = input.getBoundingClientRect();
      this.divPosition.top = rect.top + window.pageYOffset + rect.height - 365;
      this.divPosition.left = rect.left + window.pageXOffset - 20;
      // this.divPosition.top = rect.bottom + window.scrollY;
      // this.divPosition.left = rect.left + window.scrollX;
      this.divPosition.width = rect.width;
      setTimeout(() => {
        this.handleBlur("", true);
      }, 200);
    },
    handleBlur(event, type) {
      if (!type) {
        setTimeout(() => {
          this.show = false;
        }, 100);
      } else {
        this.show = true;
      }
    },
    ShifokorShablonClose() {
      this.name = "";
      this.$bvModal.hide(
        `${"modal-new-shab-creat-bayonnoma" + this.modalIdCom}`
      );
    },
    RowClickedShab($events, ind, type) { 
      if (this.row_click_type.type) {
        this.selectShablonJson[`${this.row_click_type.value}`] = type ? $events.name : $events.text;
      } else {
        let text = JSON.parse($events.text.toString());
        this.selectShablonJson = text;
      }
      this.textChange();
      this.$bvModal.hide(`${"modal-shablon" + "bayonnoma" + this.modalIdCom}`);
      this.$bvModal.hide("shablon-select" + "select" + this.modalIdCom);
    },
    getShablonDoctor(key, type) {
      let self = this;
      self.status = key;
      self.row_click_type = type;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: 1,
          doc_type: key
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    ShifokorShablon() {
      let self = this;
      let text = "";
      if (self.row_click_type.type) {
        text = self.selectShablonJson[self.row_click_type.value];
      } else {
        text = JSON.stringify(self.selectShablonJson).toString();
      }
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: {
          name: self.name,
          text: text,
          doctor_id: 1,
          doc_type: self.status ? self.status : "bayonnoma"
        }
      }).then(res => {
        if (res) {
          self.$bvModal.hide(
            `${"modal-new-shab-creat-bayonnoma" + self.modalIdCom}`
          );
        }
      });
    },
    changeHistoryId() {
      this.$emit("changeHistoryId", this.historyId);
    },
    textChange($event) {
      this.$emit(
        "statsionar_text_change",
        JSON.stringify(this.selectShablonJson).toString(),
        "bayonnoma"
      );

      // this.filteredShablon = this.itemsShablon.filter((item) => {
      //   let ok = false;
      //   if (item.name.trim().toLowerCase().includes($event.target.value.trim().toLowerCase())) {
      //     ok = true;
      //   }
      //   return ok;
      // })
    },
    plusClick() {
      this.datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    setStatus($events) {
      if ($events.keyCode == 45 || $events == 45) {
        this.datas = {
          name: this.ValueSelect,
          status: this.status
        };
        this.$bvModal.show("modal-shab-select-create" + this.modalIdCom);
      }
    },
    selectKey(key) {
      this.status = key;
      this.getShablon(key);
    },
    getShablon(status) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_select/shablonOne",
        data: { status: status }
      }).then(res => {
        if (res) {
          self.itemShablon = res.data.data;
        }
      });
    },
    userLink(item) {
      this.datas = item;
      this.$bvModal.show("modal-shab-select-create" + this.modalIdCom);
    },
    trash(id) {
      let self = this;
      axios({
        method: "delete",
        url: "/shablon_select/delete/" + id
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          // self.$bvModal.hide('modal-shab-select-create' + self.index + self.modalIdCom);
        }
      });
    },
    ValueSelChange() {
      let value = JSON.stringify(this.statsionar_text);
      // console.log(this.statsionar_text, value);
      this.$emit("selectSablon", value, this.index);
      // this.shablonData = JSON.stringify(this.statsionar_text)
    },
    ValueSel(e) {
      this.ValueSelect = e;
    },
    Shablon() {
      let self = this;
      let method = "";
      let url = "";
      if (this.datas.id) {
        method = "patch";
        url = "/shablon_select/update/" + self.datas.id;
      } else {
        self.datas.status = self.status;
        method = "post";
        url = "/shablon_select/create";
      }
      axios({
        method: method,
        url: url,
        data: self.datas
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          self.$bvModal.hide("modal-shab-select-create" + self.modalIdCom);
          self.datas = {
            id: 0,
            name: "",
            status: ""
          };
        }
      });
    },
    Close() {
      datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss">
.pencil {
  width: 35px;
  height: 35px;
  display: flex;
  background: #fff;
  border: 1px solid #e9f1fa;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}
.trash {
  background: #fff;
  width: 35px;
  height: 35px;
  display: flex;
  border: 1px solid #fff0f0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.dynamic-div {
  min-width: 150px;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 5;
  cursor: pointer;
  display: none;
  .drop-down {
    cursor: pointer;
    align-items: center;
    height: 35px;
    display: flex;
    justify-content: space-between;
    padding-left: 5px;
    font-size: 13pt;
  }
}
.drop-down:hover {
  background: rgb(46, 165, 255);
  color: #fff;
}

.stat-bemor-text {
  width: 49.5%;
  padding: 10px;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  label {
    font-family: "Times New Roman", Times, serif;
    margin-top: 5px;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
  }
  textarea {
    font-family: "Times New Roman", Times, serif;
    font-size: 13pt;
    font-weight: 500;
  }
}
.input-stile {
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: "Times New Roman", Times, serif;
  font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
  border-bottom: 1px solid #000;
}
.display-flex {
  display: flex;
}
.btn-select {
  background-color: #fff;
  border: none;
  // border: 1px  solid #000;
  // border-radius: 50%;
  font-size: 14pt;
  font-weight: 700;
  height: 27px;
  width: 27px;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  top: 3px;
  right: 25px;
  color: #6c6868;
  /* left: -50px; */
}
</style>
